import $ from 'jquery'

var ipstack_geo = {
	init: function() {
		$(window).on('load', this.init_ipstack_geo);
	},
	init_ipstack_geo: function () {

		if (typeof NOURIA_VARS === 'undefined') {
			return false;
		}

		if (typeof NOURIA_VARS.ajax_url === 'undefined') {
			return false;
		}

		var data = {
			action: 'ipstack_geo',
		};

		$.ajax({
			type: 'POST',
			url: NOURIA_VARS.ajax_url,
			data: data,
			success: function(response) {},
			dataType: 'html'
		});

		return false;
	}
};

ipstack_geo.init();

$(document).on('gform_confirmation_loaded', function(event, formId) {

	window.dataLayer = window.dataLayer || [];
	dataLayer.push({
		'event': 'g_form_submit',
		'form_id': formId
	});

});
